var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"2vh 11vw"}},[_c('newsList',{attrs:{"newsList":_vm.news_list}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }